import React from "react"
import Section from "./Section"
import Heading from "./Heading"
import { styled } from "styled-components"
import { breakpoints } from "../Theme"
import Paragraph from "./Paragraph"
import Button from "./Button"
import { Link, graphql } from "gatsby"
import Buddies from "./Buddies"
import useTracking from "../hooks/useTracking"
import Tabs from "./Tabs"

const StyledHeading = styled(Heading)`
  font-size: 34px;

  @media ${breakpoints.l} {
    font-size: 55px;
  }

  @media ${breakpoints.xxl} {
    font-size: 77px;
  }
`

const StyledLink = styled(Link)`
  color: inherit;
`

export default function Hero({
  title,
  intro,
  buttonsTitle,
  buttons,
  tabs,
  currentPage,
  children,
}) {
  const { trackEvent } = useTracking()
  return (
    <header>
      <Buddies>
        <Section size="xl" spacing="xl">
          <StyledHeading
            el="h1"
            align="center"
            spacing={intro || buttonsTitle || tabs ? "l" : "0"}
          >
            {title}
          </StyledHeading>
          {intro && (
            <Paragraph align="center" spacing="l">
              {intro}
            </Paragraph>
          )}

          {buttonsTitle && (
            <Heading el="h5" align="center" spacing="m">
              {buttonsTitle}
            </Heading>
          )}

          {tabs && buttons ? (
            <Tabs>
              {buttons.map(tab => (
                <Tabs.Tab
                  key={tab.id}
                  to={tab.field_link.url}
                  active={currentPage == tab.field_link.url}
                >
                  {tab.field_link.title}
                </Tabs.Tab>
              ))}
            </Tabs>
          ) : (
            <>
              <Button.Wrapper align="center">
                {buttons?.map(button => {
                  if (button.field_link_type !== "quaternary") {
                    return (
                      <Button
                        key={button.id}
                        to={button.field_link.url}
                        type={button.field_link_type}
                        extraClass={button.field_link.options.attributes.class}
                        onClick={() => {
                          if (
                            button.field_link.options.attributes.class[0] ===
                            "click_survey_Agree"
                          ) {
                            trackEvent({
                              event: "click_survey",
                              category: "Survey",
                              action: "CTA",
                              label: "Agree",
                            })
                          }
                          if (
                            button.field_link.options.attributes.class[0] ===
                            "click_survey_Ponder"
                          ) {
                            trackEvent({
                              event: "click_survey",
                              category: "Survey",
                              action: "CTA",
                              label: "Ponder",
                            })
                          }
                        }}
                      >
                        {button.field_link.title}
                      </Button>
                    )
                  }
                })}
              </Button.Wrapper>
              <Button.Wrapper align="center">
                {buttons?.map(button => {
                  if (button.field_link_type === "quaternary") {
                    return (
                      <StyledLink key={button.id} to={button.field_link.url}>
                        {button.field_link.title}
                      </StyledLink>
                    )
                  }
                })}
              </Button.Wrapper>
            </>
          )}
        </Section>
      </Buddies>
    </header>
  )
}

export const query = graphql`
  fragment paragraph__headerFragment on paragraph__header {
    __typename
    field_intro {
      processed
      value
    }
    field_title_html {
      value
    }
    relationships {
      field_cta_collection {
        field_title
        field_show_as_tabs
        relationships {
          field_cta {
            ...paragraph__ctaFragment
          }
        }
      }
    }
  }
`
